import React, { useCallback, useEffect, useState } from "react";
import InputText from "../../../../../components/inputs/InputText";
import baseUrl from "../../../../../api/baseUrl";
import InputDropSearch from "../../../../../components/inputs/InputDropSearch";
import { toast } from "react-toastify";

const StaffRelaseModal: React.FC<AddProductModalProps> = ({
  closeModal,
  addProduct,
}) => {
  const [formData, setformData] = useState<Product>({
    productId: "",
    unitPrice: 0,
    quantity: 1,
    total: 0,
    discount: 0,
    netTotal: 0,
    productName: "",
    availableQuantity: 0,
  });
  const [product, setProduct] = useState<Item[]>([]);

  const handleChange = useCallback((e: any) => {
    const { name, value, valueTitle, value2 } = e.target;

    setformData((prevData) => {
      if (name === "productId") {
        return {
          ...prevData,
          [name]: value,
          productName: valueTitle,
          availableQuantity: value2?.availableQuantity,
          unitPrice: parseInt(value2?.price),
          total: prevData.quantity * parseInt(value2?.price),
          netTotal:
            prevData.quantity * parseInt(value2?.price) - prevData.discount,
        };
      } else if (name === "quantity") {
        return {
          ...prevData,
          [name]: value,
          total: prevData.unitPrice * value,
          netTotal: prevData.unitPrice * value - prevData.discount,
        };
      } else if (name === "discount") {
        return {
          ...prevData,
          [name]: value,
          netTotal: prevData.total - value,
        };
      } else {
        return { ...prevData, [name]: value };
      }
    });
  }, []);
  const getProductData = useCallback(async (search: string) => {
    try {
      const response = await baseUrl.get(
        "client/inventory/purchase/searchAllProduct",
        {
          headers: {
            keyword: search,
          },
        }
      );
      setProduct(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    getProductData("");
  }, [getProductData]);

  const searchProduct = useCallback(
    (search: string) => {
      getProductData(search);
    },
    [getProductData]
  );
  const handleSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      if (
        formData.availableQuantity != undefined &&
        formData.availableQuantity > 0
      ) {
        addProduct(formData);
      } else {
        toast("out of stock");
      }
    },
    [addProduct, formData]
  );
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-[8px] shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header */}
        <div className="px-3 py-2 border-b border-slate-200 flex items-center justify-between">
          <h2 className="text-xs font-bold text-slate-800">Add Product to Staff</h2>
          <button
            onClick={closeModal}
            className="w-6 h-6 rounded-md bg-slate-100 hover:bg-slate-200 flex items-center justify-center text-slate-600 transition-colors"
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-3 space-y-3">
          <InputDropSearch
            data={product}
            name="productId"
            label="Product Name"
            selectName1="productName"
            selectName2="availableQuantity"
            noMgs="no"
            extraMsg=" stock"
            selectValue="_id"
            onChange={handleChange}
            onSearch={searchProduct}
          />

          {formData.availableQuantity > 0 && (
            <p className="text-xs text-emerald-600 bg-emerald-50 px-2.5 py-1.5 rounded-lg">
              Available: {formData.availableQuantity} in stock
            </p>
          )}

          <div className="grid grid-cols-2 gap-2.5">
            <InputText name="unitPrice" label="Unit Price" value={formData.unitPrice} onChange={handleChange} isDisable={true} />
            <InputText name="quantity" label="Quantity" value={formData.quantity} onChange={handleChange} />
          </div>

          <div className="grid grid-cols-2 gap-2.5">
            <InputText name="total" label="Total" value={formData.total} onChange={handleChange} isDisable={true} />
            <InputText name="discount" label="Discount" value={formData.discount} onChange={handleChange} />
          </div>

          <div className="p-2.5 bg-emerald-50 rounded-lg">
            <p className="text-xs text-emerald-700">
              Net Total: <span className="font-bold text-sm">{formData.netTotal}</span>
            </p>
          </div>

          <div className="flex gap-2 pt-2">
            <button
              type="button"
              onClick={closeModal}
              className="flex-1 px-4 py-2.5 rounded-lg border border-slate-200 text-slate-600 font-medium hover:bg-slate-50 transition-colors text-xs"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2.5 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all text-xs"
            >
              Add Product
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StaffRelaseModal;
interface Item {
  [key: string]: any;
}
interface AddProductModalProps {
  closeModal: () => void;
  addProduct: (product: Product) => void;
}
interface Product {
  productId: string;
  productName: string;
  unitPrice: number;
  quantity: number;
  total: number;
  discount: number;
  netTotal: number;
  availableQuantity: number;
}
